<template>
  <div class="meetingStaff">
    <navbarStaff />
    <div class="space"></div>
    <!-- <h1>{{ time_count }}</h1> -->
    <!-- <div class="space_avatar"></div> -->
    <div class="container">
      <br />
      <!-- <div class="circle_content">
        <div class="circle_floting">
          <div class="circle">
            <span class="circle__btn">
              <img
                class="circle_img"
                :src="require('@/assets/avatars/' + code + '.jpg')"
                alt=""
              />
            </span>
            <span class="circle__back-1"></span>
            <span class="circle__back-2"></span>
          </div>
        </div>
      </div> -->

      <div class="calender-list">
        <div class="card card-order-list card-margin calendar-border">
          <div class="card-body">
            <div class="container">
              <div class="card-content-more">
                <h1 class="btn-floating">
                  {{ choosedDay2.dateFormat | moment }}
                </h1>
              </div>
              <!--  -->
              <vue-horizontal-calendar
                choosedDate:dateTime
                v-on:change="dateChange2"
                lang="en"
                choosedItemColor="#ff5f2d"
                todayItemColor="#bec8e4"
                class="shadow-date"
              >
                <img
                  slot="leftIcon"
                  src="../../assets/icons/right.png"
                  style="width: 20px; margin-top: -2px"
                />
                <img
                  slot="rightIcon"
                  src="../../assets/icons/left.png"
                  style="width: 20px; margin-top: -2px"
                />
              </vue-horizontal-calendar>
            </div>
          </div>
        </div>
      </div>
      <br />
      <br />
      <!-- =================================================== input RETURN ============================ -->
      <div class="row">
        <div class="col">
          <div class="search">
            <input
              type="text"
              class="search__input"
              placeholder="Return"
              v-model="text"
              style="border-radius: 30px"
              v-on:keyup.enter="checkSTD"
              autofocus
            />
            <div class="search__icon">
              <i class="fa-solid fa-barcode"></i>
              <!-- <ion-icon name="search"></ion-icon> -->
            </div>
          </div>

          <!-- <br /> -->
          <!-- Actual search box -->
        </div>
      </div>

      <!-- =================================================== END input ============================ -->
      <!-- ============================================ Tabs Menu =============================== -->
      <br />
      <br />
      <div class="tebs_content">
        <div class="tebs_floting">
          <div class="segmented-control">
            <input
              type="radio"
              name="radio2"
              v-model="radio_btn"
              @change="onChange"
              value=""
              id="tab-1"
              checked
            />
            <label for="tab-1" class="segmented-control__1">
              <p>Meeting</p></label
            >

            <input
              type="radio"
              name="radio2"
              v-model="radio_btn"
              @change="onChange"
              value="Studio"
              id="tab-2"
            />
            <label for="tab-2" class="segmented-control__2">
              <p>Studio</p></label
            >

            <input
              type="radio"
              name="radio2"
              v-model="radio_btn"
              @change="onChange"
              value="Calendar"
              id="tab-3"
            />
            <label for="tab-3" class="segmented-control__3">
              <p>Calendar</p></label
            >

            <div class="segmented-control__color"></div>
          </div>
          <br />
        </div>
      </div>

      <!-- ============================================ END Tabs Menu =============================== -->
      <!-- ============================================ Tabs Detail =============================== -->

      <!-- ********************************************* STUDIO & RACORD  ********************************* -->
      <div class="bv-example-row mt-5" v-if="radio_btn === 'Studio'">
        <div class="card-columns">
          <b-card no-body class="mb-12 border-0">
            <!-- <b-card-body >
              <h4>ไม่มีรายการจองห้อง</h4>
            </b-card-body> -->
            <b-card-body >
              <div class="card-columns-three">
                <span v-for="(stu, inc) in histories" :key="inc">
                  <div
                    class="card card-order-list card-margin shadow-item shadow-sm"
                    v-if="
                      stu.room_id === 8 ||
                      stu.room_id === 9 ||
                      stu.room_id === 10
                    "
                  >
                    <!--  -->
                    <div
                      class="card-body text-left"
                      style="position: relative"
                      v-if="stu.trans_status === 'booked'"
                    >
                      <div
                        style="
                          position: absolute;
                          font-size: 14px;
                          color: black;
                          right: 10px;
                          margin-top: -10px;
                        "
                        class="interior"
                      >
                        <a class="btn" :href="`#open-modal-stu${stu.order_id}`"
                          ><i class="fa-solid fa-ellipsis-vertical fa-lg"></i
                        ></a>
                      </div>

                      <p
                        style="
                          font-size: 0.8rem;
                          margin-bottom: 10px;
                          background-color: #17a2b8;
                          width: 80px;
                          padding: 4px;
                          border-radius: 40px;
                          color: aliceblue;
                        "
                        class="text-center"
                      >
                        <b>BOOKED</b>
                      </p>
                      <p
                        style="font-size: 1.2rem"
                        class="justify-content-center"
                      >
                        {{ stu.room_name }} :
                        <b>{{ stu.time_begin }} - {{ stu.time_end }}</b> <br />
                        วัตถุประสงค์ : {{ stu.usefor_name }}
                      </p>
                    </div>
                    <!-- end booked -->
                    <!-- confirm -->
                    <div
                      class="card-body text-left"
                      style="position: relative"
                      v-if="stu.trans_status === 'confirmed'"
                    >
                      <div
                        style="
                          position: absolute;
                          font-size: 14px;
                          color: black;
                          right: 10px;
                          margin-top: -10px;
                        "
                        class="interior"
                      >
                        <a class="btn" :href="`#open-modal-stu${stu.order_id}`"
                          ><i class="fa-solid fa-ellipsis-vertical fa-lg"></i
                        ></a>
                      </div>

                      <p
                        style="
                          font-size: 0.8rem;
                          margin-bottom: 10px;
                          background-color: #5b0eeb;
                          width: 80px;
                          padding: 4px;
                          border-radius: 40px;
                          color: aliceblue;
                        "
                        class="text-center"
                      >
                        <b>APPROVE</b>
                      </p>
                      <p
                        style="font-size: 1.2rem"
                        class="justify-content-center"
                      >
                        {{ stu.room_name }}
                      </p>
                      <p
                        style="font-size: 1.2rem"
                        class="justify-content-center"
                      >
                        {{ stu.time_begin }} -
                        {{ stu.time_end }}
                      </p>

                      <b-button
                        variant="outline-purple"
                        pill
                        class="pull-right mb-2 mt-0"
                        size="md"
                        :href="`#modal-approved-stu${stu.order_id}`"
                        v-if="!statusalert"
                        >APPROVE</b-button
                      >
                    </div>
                    <!-- end confirm -->
                    <!-- approved -->
                    <div
                      class="card-body text-left"
                      style="position: relative"
                      v-if="stu.trans_status === 'approved'"
                    >
                      <div
                        style="
                          position: absolute;
                          font-size: 14px;
                          color: black;
                          right: 10px;
                          margin-top: -10px;
                        "
                        class="interior"
                      >
                        <a class="btn" :href="`#open-modal-stu${stu.order_id}`"
                          ><i class="fa-solid fa-ellipsis-vertical fa-lg"></i
                        ></a>
                      </div>

                      <p
                        style="
                          font-size: 0.8rem;
                          margin-bottom: 10px;
                          background-color: #05900c;
                          width: 80px;
                          padding: 4px;
                          border-radius: 40px;
                          color: aliceblue;
                        "
                        class="text-center"
                      >
                        <b>ON LINE</b>
                      </p>
                      <p
                        style="font-size: 1.2rem"
                        class="justify-content-center"
                      >
                        {{ stu.room_name }} <br />
                        <b> {{ stu.time_begin }} - {{ stu.time_end }}</b>
                      </p>
                      <b-button
                        variant="outline-success"
                        pill
                        class="pull-right mb-2 mt--2"
                        size="md"
                        @click="end(stu.order_token)"
                        v-if="!statusalert"
                        >DONE</b-button
                      >
                    </div>
                    <!-- END approved -->
                    <!-- completed -->
                    <div
                      class="card-body text-left bg-light text-muted"
                      style="
                        position: relative;
                        pointer-events: none;
                        opacity: 0.6;
                      "
                      v-if="stu.trans_status === 'completed'"
                      aria-disabled="true"
                    >
                      <div
                        style="
                          position: absolute;
                          font-size: 14px;
                          color: black;
                          right: 10px;
                          margin-top: -10px;
                        "
                        class="interior"
                      >
                        <a class="btn" :href="`#open-modal-stu${stu.order_id}`"
                          ><i class="fa-solid fa-ellipsis-vertical fa-lg"></i
                        ></a>
                      </div>

                      <p
                        style="
                          font-size: 0.8rem;
                          margin-bottom: 10px;
                          background-color: #000000;
                          width: 80px;
                          padding: 4px;
                          border-radius: 40px;
                          color: aliceblue;
                        "
                        class="text-center"
                      >
                        <b>DONE</b>
                      </p>
                      <p
                        style="font-size: 1.2rem"
                        class="justify-content-center"
                      >
                        {{ stu.room_name }} :
                        <b> {{ stu.time_begin }} - {{ stu.time_end }}</b
                        ><br />
                        ชื่อผู้ใช้ : {{ stu.whois_std_name }} <br />
                      </p>
                    </div>
                    <!-- END completed -->

                    <!-- ======================================================= MODAL STU ====================================================== -->
                    <!-- ************************************* MODAL DETAIL ************************************* -->

                    <div
                      :id="`open-modal-stu${stu.order_id}`"
                      class="modal-window"
                    >
                      <div>
                        <a href="#" title="Close" class="modal-close"
                          ><i class="fa-solid fa-xmark fa-2x mt-3"></i
                        ></a>

                        <h1 class="justify-content-center text-left">
                          {{ stu.room_name }}
                        </h1>
                        <p class="justify-content-center text-left">
                          TIME : {{ stu.time_begin }} -
                          {{ stu.time_end }}
                        </p>
                        <p class="justify-content-center text-left">
                          NAME : {{ stu.whois_std_name }}
                        </p>
                        <p class="justify-content-center text-left">
                          STD CODE : {{ stu.whois_std_code }}
                        </p>

                        <p class="justify-content-center text-left">
                          DATE : {{ stu.meeting_date | moment }}
                        </p>

                        <div>
                          <small> รายละเอียดการจองห้องศึกษากลุ่มย่อย </small>
                        </div>
                      </div>
                    </div>

                    <!-- ************************************* END MODAL DETAIL ************************************* -->

                    <!-- modal APPROVED EVENT -->

                    <div
                      class="modal-window"
                      :id="`modal-approved-stu${stu.order_id}`"
                    >
                      <div>
                        <h6
                          style="
                            font-size: 0.8rem;
                            margin-bottom: 10px;
                            background-color: #5b0eeb;
                            width: 100px;
                            padding: 4px;
                            border-radius: 40px;
                            color: aliceblue;
                          "
                          class="text-center"
                        >
                          <b>ยืนยันจองห้อง </b>
                        </h6>
                        <h3 class="justify-content-center text-left">
                          {{ stu.room_name }}
                        </h3>
                        <h5 class="justify-content-center text-left">
                          {{ stu.time_begin }} -
                          {{ stu.time_end }}
                        </h5>
                        <div class="d-flex justify-content-end gap-4">
                          <a
                            href="#"
                            class="btn btn-outline-info ml-2 rounded-pill"
                            size="md"
                            @click="approve(stu.order_token)"
                          >
                            ยืนยัน
                          </a>
                          <a
                            class="btn btn-outline-secondary ml-2 rounded-pill"
                            size="md"
                            href="#"
                            >ยกเลิก</a
                          >
                        </div>
                      </div>
                    </div>

                    <!-- modal DONE EVENT -->

                    <!-- ======================================================= END MODAL STU ====================================================== -->
                  </div>
                </span>
              </div>
            </b-card-body>
          </b-card>
        </div>
      </div>

      <!-- ********************************************* END STUDIO & RACORD  ********************************* -->

      <!--  -->
      <div class="bv-example-row mt-5" v-if="radio_btn === 'Calendar'">
        <div class="col">
          <div class="card card-order-list border-light shadow-sm">
            <div class="card-body">
              <FullCalendar
                :options="calendarOptions"
                ref="fullCalendar"
                :available-dates="{ start: new Date(), end: null }"
              />
            </div>
          </div>
        </div>
      </div>
      <!--  -->

      <!-- ============================================ END Tabs Detail =============================== -->
    </div>

    <!-- ********************************************* METTING ROOM ********************************* -->
    <span v-if="radio_btn === ''">
      <b-container class="bv-example-row" style="margin-top: -10px">
        <b-row no-gutters class="d-none d-md-flex">
          <b-col class="px-1" cols="auto">
            <div class="text-center">
              <b-button
                pill
                variant="outline-info"
                class="shadow-sm"
                :href="`#open-modal-length-booked`"
              >
                Booked <b-badge variant="info" pill>{{ booked }}</b-badge>
              </b-button>
            </div>
          </b-col>

          <b-col class="px-1" cols="auto">
            <div class="text-center">
              <b-button
                pill
                variant="outline-purple"
                class="shadow-sm"
                :href="`#open-modal-length-inlocker`"
              >
                In Progress
                <b-badge style="background-color: #6f42c1; color: white" pill>{{
                  inProgress
                }}</b-badge>
              </b-button>
            </div>
          </b-col>

          <b-col class="px-1" cols="auto">
            <div class="text-center">
              <b-button
                pill
                variant="outline-success"
                class="shadow-sm"
                :href="`#open-modal-length-borrowed`"
              >
                Borrowed
                <b-badge variant="success" pill>{{ borrowed }}</b-badge>
              </b-button>
            </div>
          </b-col>

          <b-col class="px-1" cols="auto">
            <div class="text-center">
              <b-button
                pill
                variant="outline-secondary"
                class="shadow-sm"
                :href="`#open-modal-length-returned`"
              >
                Return
                <b-badge variant="secondary" pill>{{ returned }}</b-badge>
              </b-button>
            </div>
          </b-col>
          <!-- <b-button v-b-modal.modal-1>Launch demo modal</b-button> :href="`#open-modal-bookroomVIP`"-->
          <!-- <b-col class="px-1" cols="auto">
            <div class="text-center">
              <b-button
                pill
                variant="outline-danger"
                class="shadow-sm"
                v-b-modal.modal-1
              >
                จองห้อง
              </b-button>
            </div>
          </b-col> -->
        </b-row>
        <!-- ================================================= MODAL MENU LENGTH ======================================== -->

        <!-- booked -->
        <div :id="`open-modal-length-booked`" class="modal-window">
          <div>
            <a href="#" title="Close" class="modal-close"
              ><i class="fa-solid fa-xmark fa-2x mt-3"></i
            ></a>
            <br />
            <span v-for="(allitem, index) in histories" :key="index">
              <span
                v-if="
                  allitem.trans_status === 'booked' &&
                  booked !== 0 &&
                  allitem.room_id !== 8 &&
                  allitem.room_id !== 9 &&
                  allitem.room_id !== 10
                "
              >
                <p class="text-left">
                  <i class="fa-solid fa-circle" style="color: #17a2b8"></i>
                  {{ allitem.room_name }} | {{ allitem.time_begin }} -
                  {{ allitem.time_end }}
                </p>

                <!-- <div>
                <small> รายละเอียดการจองห้องศึกษากลุ่มย่อย </small>
              </div> -->
              </span>
            </span>
            <span v-if="booked === 0">
              <p>ไม่มีรายการห้อง รอยืนยัน</p>
            </span>
          </div>
        </div>
        <!-- end -->
        <!-- borrow -->
        <div :id="`open-modal-length-borrowed`" class="modal-window">
          <div>
            <a href="#" title="Close" class="modal-close"
              ><i class="fa-solid fa-xmark fa-2x mt-3"></i
            ></a>
            <br />
            <span v-for="(allitem, index) in histories" :key="index">
              <span
                v-if="
                  allitem.trans_status === 'borrowed' &&
                  borrowed !== 0 &&
                  allitem.room_id !== 8 &&
                  allitem.room_id !== 9 &&
                  allitem.room_id !== 10
                "
              >
                <p class="text-left">
                  <i class="fa-solid fa-circle" style="color: #00b303"></i>
                  {{ allitem.room_name }} | {{ allitem.time_begin }} -
                  {{ allitem.time_end }}
                </p>

                <!-- <div>
                <small> รายละเอียดการจองห้องศึกษากลุ่มย่อย </small>
              </div> -->
              </span>
            </span>
            <span v-if="borrowed === 0">
              <p>ไม่มีรายการห้อง กำลังใช้งาน</p>
            </span>
          </div>
        </div>
        <!-- end -->

        <!-- inlocker-->
        <div :id="`open-modal-length-inlocker`" class="modal-window">
          <div>
            <a href="#" title="Close" class="modal-close"
              ><i class="fa-solid fa-xmark fa-2x mt-3"></i
            ></a>
            <br />
            <span v-for="(allitem, index) in histories" :key="index">
              <span
                v-if="
                  allitem.trans_status === 'inlocker' &&
                  inProgress !== 0 &&
                  allitem.room_id !== 8 &&
                  allitem.room_id !== 9 &&
                  allitem.room_id !== 10
                "
              >
                <p class="text-left">
                  <i class="fa-solid fa-circle" style="color: #6f42c1"></i>
                  {{ allitem.room_name }} | {{ allitem.time_begin }} -
                  {{ allitem.time_end }}
                </p>
              </span>
            </span>
            <span v-if="inProgress === 0">
              <p>ไม่มีรายการห้อง ที่ต้องรับกุญแจ</p>
            </span>
          </div>
        </div>
        <!-- END -->

        <!-- inlocker-->
        <div :id="`open-modal-length-returned`" class="modal-window">
          <div>
            <a href="#" title="Close" class="modal-close"
              ><i class="fa-solid fa-xmark fa-2x mt-3"></i
            ></a>
            <br />
            <span v-for="(allitem, index) in histories" :key="index">
              <span
                v-if="
                  allitem.trans_status === 'returned' &&
                  returned !== 0 &&
                  allitem.room_id !== 8 &&
                  allitem.room_id !== 9 &&
                  allitem.room_id !== 10
                "
              >
                <p class="text-left">
                  <i class="fa-solid fa-circle" style="color: #6c757d"></i>
                  {{ allitem.room_name }} | {{ allitem.time_begin }} -
                  {{ allitem.time_end }}
                </p>
              </span>
            </span>
            <span v-if="returned === 0">
              <p>ไม่มีรายการ คืนห้อง</p>
            </span>
          </div>
        </div>
        <!-- END -->

        <!-- Book Room -->
        <div>
          <b-modal id="modal-1" title="จองห้อง" size="lg">
           

            <form class="form-group">
              <b-row>
                <b-col cols="6">
                  <input
                    type="text"
                    name=""
                    id=""
                    class="form-control input-style"
                    placeholder="รหัสอาจารย์"
                    maxlength="11"
                  />
                </b-col>
                <b-col cols="6">
                  <input
                    type="text"
                    name=""
                    id=""
                    class="form-control input-style"
                    placeholder="เบอร์โทรศัพท์"
                    maxlength="10"
                  />
                </b-col>

                <b-col cols="6">
                  <b-form-select
                    v-model="selectedfac"
                    :options="optionsfac"
                    value-field="fac_code"
                    class="mb-3 input-style"
                    text-field="fac_name"
                    disabled-field="notEnabled"
                    @change="get_branch()"
                  >
                    <!-- Teacher -->
                    <template #first>
                      <b-form-select-option :value="null" disabled>
                        เลือกคณะ
                      </b-form-select-option>
                    </template>
                  </b-form-select>
                </b-col>
                
                <b-col cols="6">
                  <b-form-select
                    v-model="selectedbranch"
                    :options="optionsbranch"
                    class="mb-3 input-style"
                    value-field="branch_code"
                    text-field="branch_name"
                    disabled-field="notEnabled"
                  >
                    <!-- Teacher -->
                    <template #first>
                      <b-form-select-option :value="null" disabled>
                        เลือกสาขา
                      </b-form-select-option>
                    </template>
                  </b-form-select>
                </b-col>

                <b-col cols="6"> 
                  <b-form-select
                    v-model="selectedbranch"
                    :options="optionsbranch"
                    class="mb-3 input-style"
                    value-field="branch_code"
                    text-field="branch_name"
                    disabled-field="notEnabled"
                  >
                    <!-- Teacher -->
                    <template #first>
                      <b-form-select-option :value="null" disabled>
                        เลือกห้อง
                      </b-form-select-option>
                    </template>
                  </b-form-select>
                </b-col>


              </b-row>
            </form>
          </b-modal>
        </div>

        <!-- END -->
        <br />
      </b-container>
      <!--  -->
      <br class="d-flex d-md-none" />
      <br class="d-flex d-md-none" />
      <div class="container-fluid">
        <div class="row">
          <div class="col"></div>
          <div class="col-10">
            <div class="card-columns-two">
              <!-- ================================ Morning ====================================-->

              <div class="card-columns">
                <b-card no-body class="mb-4">
                  <b-card-header
                    header-tag="header"
                    class="bg-dark text-white d-flex justify-content-between align-items-center"
                    @click="isOpen1 = !isOpen1"
                  >
                    <div>ช่วงเช้า 08:30 - 12:00</div>
                    <b-icon :icon="isOpen1 ? 'chevron-up' : 'chevron-down'" />
                  </b-card-header>

                  <b-collapse v-model="isOpen1">
                    <b-card-body>
                      <!-- ======================================================= BOOKED MORNING  =======================================================-->

                      <div class="card-columns-three">
                        <span v-for="(moorning, ind) in histories" :key="ind">
                          <span
                            v-if="
                              [1, 2, 3, 4, 5, 6, 7, 24, 25, 26, 27].includes(
                                moorning.room_id
                              ) && moorning.time_begin === '08:30'
                            "
                          >
                            <div
                              class="card card-order-list card-margin shadow-item shadow-sm"
                              v-if="
                                choosedDay2.dateFormat.moment ===
                                  moorning.meeting_date.moment &&
                                moorning.trans_status === 'booked' &&
                                moorning.time_begin === '08:30'
                              "
                            >
                              <div
                                class="card-body text-left"
                                style="position: relative"
                              >
                                <div
                                  style="
                                    position: absolute;
                                    font-size: 14px;
                                    color: black;
                                    right: 10px;
                                    margin-top: -10px;
                                  "
                                  class="interior"
                                >
                                  <a
                                    class="btn"
                                    :href="`#open-modal${moorning.order_id}`"
                                    ><i
                                      class="fa-solid fa-ellipsis-vertical fa-lg"
                                    ></i
                                  ></a>
                                </div>

                                <p
                                  style="
                                    font-size: 0.8rem;
                                    margin-bottom: 10px;
                                    background-color: #17a2b8;
                                    width: 80px;
                                    padding: 4px;
                                    border-radius: 40px;
                                    color: aliceblue;
                                  "
                                  class="text-center"
                                >
                                  <b>BOOKED</b>
                                </p>
                                <p
                                  style="font-size: 1.2rem"
                                  class="justify-content-center"
                                >
                                  {{ moorning.room_name }}
                                </p>
                                <span v-if="moorning.trans_status === 'booked'">
                                  <b-button
                                    variant="outline-info"
                                    pill
                                    class="pull-right mb-2"
                                    size="sm"
                                    :href="`#modal-confirm-meeting-moorning${moorning.order_id}`"
                                    >Confirm</b-button
                                  >
                                  <!-- ************************************************************** MODAL CONFIRM MORNING ************************************************************** -->
                                  <div
                                    class="modal-window"
                                    :id="`modal-confirm-meeting-moorning${moorning.order_id}`"
                                  >
                                    <div>
                                      <h6
                                        style="
                                          font-size: 0.8rem;
                                          margin-bottom: 10px;
                                          background-color: #17a2b8;
                                          width: 100px;
                                          padding: 4px;
                                          border-radius: 40px;
                                          color: aliceblue;
                                        "
                                        class="text-center"
                                      >
                                        <b>ยืนยันจองห้อง </b>
                                      </h6>
                                      <h3>{{ moorning.room_name }}</h3>
                                      <h5>
                                        {{ moorning.time_begin }} -
                                        {{ moorning.time_end }}
                                      </h5>
                                      <div
                                        class="d-flex justify-content-end gap-4"
                                      >
                                        <a
                                          href="#"
                                          class="btn btn-outline-info ml-2 rounded-pill"
                                          size="md"
                                          @click="inlocker(moorning.order_id)"
                                        >
                                          ยืนยัน
                                        </a>
                                        <a
                                          class="btn btn-outline-secondary ml-2 rounded-pill"
                                          size="md"
                                          href="#"
                                          >ยกเลิก</a
                                        >
                                      </div>
                                    </div>
                                  </div>

                                  <!-- ************************************************************** END MODAL CONFIRM MORNING ************************************************************** -->
                                </span>
                              </div>

                              <!-- =============================================================== MODAL DETAIL MORNING =========================================================== -->
                              <div
                                :id="`open-modal${moorning.order_id}`"
                                class="modal-window"
                              >
                                <div>
                                  <a href="#" title="Close" class="modal-close"
                                    ><i class="fa-solid fa-xmark fa-2x mt-3"></i
                                  ></a>
                                  <h1 class="justify-content-center text-left">
                                    {{ moorning.room_name }}
                                  </h1>
                                  <p class="justify-content-center text-left">
                                    TIME : {{ moorning.time_begin }} -
                                    {{ moorning.time_end }}
                                  </p>
                                  <p class="justify-content-center text-left">
                                    NAME : {{ moorning.whois_std_name }}
                                  </p>
                                  <p class="justify-content-center text-left">
                                    STD CODE : {{ moorning.whois_std_code }}
                                  </p>
                                  <p class="justify-content-center text-left">
                                    LOCKER : {{ moorning.locker_number }}
                                  </p>
                                  <p class="justify-content-center text-left">
                                    DATE : {{ moorning.meeting_date | moment }}
                                  </p>

                                  <div>
                                    <small>
                                      รายละเอียดการจองห้องศึกษากลุ่มย่อย
                                    </small>
                                  </div>
                                </div>
                              </div>
                              <!-- =============================================================== END MODAL DETAIL MORNING =========================================================== -->
                            </div>
                          </span>
                        </span>
                      </div>
                      <!-- ======================================================= END BOOKED MORNING  =======================================================-->

                      <!-- ======================================================= IN PROGRESS MORNING  =======================================================-->
                      <div class="card-columns-three">
                        <span v-for="(inlocker, ind) in histories" :key="ind">
                          <span
                            v-if="
                              [1, 2, 3, 4, 5, 6, 7, 24, 25, 26, 27].includes(
                                inlocker.room_id
                              ) && inlocker.time_begin === '08:30'
                            "
                          >
                            <div
                              class="card card-order-list card-margin shadow-item shadow-sm"
                              v-if="
                                choosedDay2.dateFormat.moment ===
                                  inlocker.meeting_date.moment &&
                                inlocker.trans_status === 'inlocker' &&
                                inlocker.time_begin === '08:30'
                              "
                            >
                              <div
                                class="card-body text-left"
                                style="position: relative"
                              >
                                <div
                                  style="
                                    position: absolute;
                                    font-size: 14px;
                                    color: black;
                                    right: 10px;
                                    margin-top: -10px;
                                  "
                                  class="interior"
                                >
                                  <a
                                    class="btn"
                                    :href="`#open-modal-inlocker-morning${inlocker.order_id}`"
                                    ><i
                                      class="fa-solid fa-ellipsis-vertical fa-lg"
                                    ></i
                                  ></a>
                                </div>

                                <p
                                  style="
                                    font-size: 0.8rem;
                                    margin-bottom: 10px;
                                    background-color: #5b0eeb;
                                    width: 100px;
                                    padding: 4px;
                                    border-radius: 40px;
                                    color: aliceblue;
                                  "
                                  class="text-center"
                                >
                                  <b>IN PROGRESS</b>
                                </p>
                                <p
                                  style="font-size: 1.2rem"
                                  class="justify-content-center mb-0"
                                >
                                  {{ inlocker.room_name }}
                                </p>
                                <span
                                  v-if="inlocker.trans_status === 'inlocker'"
                                >
                                  <router-link
                                    :to="'/locker/' + inlocker.locker_number"
                                    class="nav-link pull-right"
                                    target="_blank"
                                  >
                                    <b-button
                                      variant="outline-purple"
                                      pill
                                      class="pull-right mb-2 mt-0 pull-right"
                                      size="sm"
                                      >รับกุญแจ</b-button
                                    >
                                  </router-link>

                                  <!-- ************************************************************** MODAL CONFIRM AFTERNOON ************************************************************** -->

                                  <!-- ************************************************************** END MODAL CONFIRM AFTERNOON  ************************************************************** -->
                                </span>
                              </div>

                              <!-- =============================================================== MODAL DETAIL AFTERNOON  =========================================================== -->
                              <div
                                :id="`open-modal-inlocker-morning${inlocker.order_id}`"
                                class="modal-window"
                              >
                                <div>
                                  <a href="#" title="Close" class="modal-close"
                                    ><i class="fa-solid fa-xmark fa-2x mt-3"></i
                                  ></a>
                                  <h1 class="justify-content-center text-left">
                                    {{ inlocker.room_name }}
                                  </h1>
                                  <p class="justify-content-center text-left">
                                    TIME : {{ inlocker.time_begin }} -
                                    {{ inlocker.time_end }}
                                  </p>
                                  <p class="justify-content-center text-left">
                                    NAME : {{ inlocker.whois_std_name }}
                                  </p>
                                  <p class="justify-content-center text-left">
                                    STD CODE : {{ inlocker.whois_std_code }}
                                  </p>
                                  <p class="justify-content-center text-left">
                                    LOCKER : {{ inlocker.locker_number }}
                                  </p>
                                  <p class="justify-content-center text-left">
                                    DATE : {{ inlocker.meeting_date | moment }}
                                  </p>

                                  <div>
                                    <small>
                                      รายละเอียดการจองห้องศึกษากลุ่มย่อย
                                    </small>
                                  </div>
                                </div>
                              </div>
                              <!-- =============================================================== END MODAL DETAIL AFTERNOON  =========================================================== -->
                            </div>
                          </span>
                        </span>
                      </div>
                      <!-- ======================================================= END  IN PROGRESS MORNING  =======================================================-->
                      <!-- ======================================================= BORROWED MORNING  =======================================================-->
                      <div class="card-columns-three">
                        <span v-for="(borrowed, ind) in histories" :key="ind">
                          <span
                            v-if="
                              [1, 2, 3, 4, 5, 6, 7, 24, 25, 26, 27].includes(
                                borrowed.room_id
                              ) && borrowed.time_begin === '08:30'
                            "
                          >
                            <div
                              class="card card-order-list card-margin shadow-item shadow-sm"
                              v-if="
                                choosedDay2.dateFormat.moment ===
                                  borrowed.meeting_date.moment &&
                                borrowed.trans_status === 'borrowed' &&
                                borrowed.time_begin === '08:30'
                              "
                            >
                              <div
                                class="card-body text-left"
                                style="position: relative"
                              >
                                <div
                                  style="
                                    position: absolute;
                                    font-size: 14px;
                                    color: black;
                                    right: 10px;
                                    margin-top: -10px;
                                  "
                                  class="interior"
                                >
                                  <a
                                    class="btn"
                                    :href="`#open-modal-borrowed-morning${borrowed.order_id}`"
                                    ><i
                                      class="fa-solid fa-ellipsis-vertical fa-lg"
                                    ></i
                                  ></a>
                                </div>

                                <p
                                  style="
                                    font-size: 0.8rem;
                                    margin-bottom: 10px;
                                    background-color: #28a745;
                                    width: 100px;
                                    padding: 4px;
                                    border-radius: 40px;
                                    color: aliceblue;
                                  "
                                  class="text-center"
                                >
                                  <b>BORROWED</b>
                                </p>
                                <p
                                  style="font-size: 1.2rem"
                                  class="justify-content-center mb-0"
                                >
                                  {{ borrowed.room_name }}
                                </p>

                                <!-- ************************************************************** MODAL CONFIRM AFTERNOON ************************************************************** -->

                                <!-- ************************************************************** END MODAL CONFIRM AFTERNOON  ************************************************************** -->
                              </div>

                              <!-- =============================================================== MODAL DETAIL AFTERNOON  =========================================================== -->
                              <div
                                :id="`open-modal-borrowed-morning${borrowed.order_id}`"
                                class="modal-window"
                              >
                                <div>
                                  <a href="#" title="Close" class="modal-close"
                                    ><i class="fa-solid fa-xmark fa-2x mt-3"></i
                                  ></a>
                                  <h1 class="justify-content-center text-left">
                                    {{ borrowed.room_name }}
                                  </h1>
                                  <p class="justify-content-center text-left">
                                    TIME : {{ borrowed.time_begin }} -
                                    {{ borrowed.time_end }}
                                  </p>
                                  <p class="justify-content-center text-left">
                                    NAME : {{ borrowed.whois_std_name }}
                                  </p>
                                  <p class="justify-content-center text-left">
                                    STD CODE : {{ borrowed.whois_std_code }}
                                  </p>
                                  <p class="justify-content-center text-left">
                                    LOCKER : {{ borrowed.locker_number }}
                                  </p>
                                  <p class="justify-content-center text-left">
                                    DATE : {{ borrowed.meeting_date | moment }}
                                  </p>

                                  <div>
                                    <small>
                                      รายละเอียดการจองห้องศึกษากลุ่มย่อย
                                    </small>
                                  </div>
                                </div>
                              </div>
                              <!-- =============================================================== END MODAL DETAIL AFTERNOON  =========================================================== -->
                            </div>
                          </span>
                        </span>
                      </div>
                      <!-- ======================================================= END BORROWED MORNING  =======================================================-->
                    </b-card-body>
                  </b-collapse>
                </b-card>
              </div>
              <!-- ================================ END Morning ====================================-->
              <!-- =============================== After noon  =============================== -->
              <div class="card-columns">
                <b-card no-body class="mb-4">
                  <b-card-header
                    header-tag="header"
                    class="bg-dark text-white d-flex justify-content-between align-items-center"
                    @click="isOpen2 = !isOpen2"
                  >
                    <div>ช่วงบ่าย 13:00 - 16:30</div>
                    <b-icon :icon="isOpen2 ? 'chevron-up' : 'chevron-down'" />
                  </b-card-header>

                  <b-collapse v-model="isOpen2">
                    <b-card-body>
                      <!--  =================================================== BOOKED AFTERNOON   ===================================================-->
                      <div class="card-columns-three">
                        <span
                          v-for="(afternoon, inda) in histories"
                          :key="inda"
                        >
                          <span
                            v-if="
                              [1, 2, 3, 4, 5, 6, 7, 24, 25, 26, 27].includes(
                                afternoon.room_id
                              ) && afternoon.time_begin === '13:00'
                            "
                          >
                            <div
                              class="card card-order-list card-margin shadow-item shadow-sm"
                              v-if="
                                choosedDay2.dateFormat.moment ===
                                  afternoon.meeting_date.moment &&
                                afternoon.trans_status === 'booked' &&
                                afternoon.time_begin === '13:00'
                              "
                            >
                              <div
                                class="card-body text-left"
                                style="position: relative"
                              >
                                <div
                                  style="
                                    position: absolute;
                                    font-size: 14px;
                                    color: black;
                                    right: 10px;
                                    margin-top: -10px;
                                  "
                                  class="interior"
                                >
                                  <a
                                    class="btn"
                                    :href="`#open-modal-afternoon${afternoon.order_id}`"
                                    ><i
                                      class="fa-solid fa-ellipsis-vertical fa-lg"
                                    ></i
                                  ></a>
                                </div>

                                <p
                                  style="
                                    font-size: 0.8rem;
                                    margin-bottom: 10px;
                                    background-color: #17a2b8;
                                    width: 80px;
                                    padding: 4px;
                                    border-radius: 40px;
                                    color: aliceblue;
                                  "
                                  class="text-center"
                                >
                                  <b>BOOKED</b>
                                </p>
                                <p
                                  style="font-size: 1.2rem"
                                  class="justify-content-center"
                                >
                                  {{ afternoon.room_name }}
                                </p>
                                <span
                                  v-if="afternoon.trans_status === 'booked'"
                                >
                                  <b-button
                                    variant="outline-info"
                                    pill
                                    class="pull-right mb-2"
                                    size="sm"
                                    :href="`#modal-confirm-meeting-afternoon${afternoon.order_id}`"
                                    >Confirm</b-button
                                  >
                                  <!-- ************************************************************** MODAL CONFIRM AFTERNOON ************************************************************** -->
                                  <div
                                    class="modal-window"
                                    :id="`modal-confirm-meeting-afternoon${afternoon.order_id}`"
                                  >
                                    <div>
                                      <h6
                                        style="
                                          font-size: 0.8rem;
                                          margin-bottom: 10px;
                                          background-color: #17a2b8;
                                          width: 100px;
                                          padding: 4px;
                                          border-radius: 40px;
                                          color: aliceblue;
                                        "
                                        class="text-center"
                                      >
                                        <b>ยืนยันจองห้อง </b>
                                      </h6>
                                      <h3>{{ afternoon.room_name }}</h3>
                                      <h5>
                                        {{ afternoon.time_begin }} -
                                        {{ afternoon.time_end }}
                                      </h5>
                                      <div
                                        class="d-flex justify-content-end gap-4"
                                      >
                                        <a
                                          href="#"
                                          class="btn btn-outline-info ml-2 rounded-pill"
                                          size="md"
                                          @click="inlocker(afternoon.order_id)"
                                        >
                                          ยืนยัน
                                        </a>
                                        <a
                                          class="btn btn-outline-secondary ml-2 rounded-pill"
                                          size="md"
                                          href="#"
                                          >ยกเลิก</a
                                        >
                                      </div>
                                    </div>
                                  </div>
                                  <!-- ************************************************************** END MODAL CONFIRM AFTERNOON  ************************************************************** -->
                                </span>
                              </div>

                              <!-- =============================================================== MODAL DETAIL AFTERNOON  =========================================================== -->
                              <div
                                :id="`open-modal-afternoon${afternoon.order_id}`"
                                class="modal-window"
                              >
                                <div>
                                  <a href="#" title="Close" class="modal-close"
                                    ><i class="fa-solid fa-xmark fa-2x mt-3"></i
                                  ></a>
                                  <h1 class="justify-content-center text-left">
                                    {{ afternoon.room_name }}
                                  </h1>
                                  <p class="justify-content-center text-left">
                                    TIME : {{ afternoon.time_begin }} -
                                    {{ afternoon.time_end }}
                                  </p>
                                  <p class="justify-content-center text-left">
                                    NAME : {{ afternoon.whois_std_name }}
                                  </p>
                                  <p class="justify-content-center text-left">
                                    STD CODE : {{ afternoon.whois_std_code }}
                                  </p>
                                  <p class="justify-content-center text-left">
                                    LOCKER : {{ afternoon.locker_number }}
                                  </p>
                                  <p class="justify-content-center text-left">
                                    DATE : {{ afternoon.meeting_date | moment }}
                                  </p>

                                  <div>
                                    <small>
                                      รายละเอียดการจองห้องศึกษากลุ่มย่อย
                                    </small>
                                  </div>
                                </div>
                              </div>
                              <!-- =============================================================== END MODAL DETAIL AFTERNOON  =========================================================== -->
                            </div>
                          </span>
                        </span>
                      </div>
                      <!--  =================================================== END BOOKED AFTERNOON   ===================================================-->

                      <!--  =================================================== IN PROGRESS AFTERNOON   ===================================================-->
                      <div class="card-columns-three">
                        <span v-for="(inlocker, ind) in histories" :key="ind">
                          <span
                            v-if="
                              [1, 2, 3, 4, 5, 6, 7, 24, 25, 26, 27].includes(
                                inlocker.room_id
                              ) && inlocker.time_begin === '13:00'
                            "
                          >
                            <!-- shadow-item shadow-sm -->
                            <div
                              class="card card-order-list card-margin shadow-item shadow-sm"
                              v-if="
                                choosedDay2.dateFormat.moment ===
                                  inlocker.meeting_date.moment &&
                                inlocker.trans_status === 'inlocker' &&
                                inlocker.time_begin === '13:00'
                              "
                            >
                              <div
                                class="card-body text-left"
                                style="position: relative"
                              >
                                <div
                                  style="
                                    position: absolute;
                                    font-size: 14px;
                                    color: black;
                                    right: 10px;
                                    margin-top: -10px;
                                  "
                                  class="interior"
                                >
                                  <a
                                    class="btn"
                                    :href="`#open-modal-inlocker${inlocker.order_id}`"
                                    ><i
                                      class="fa-solid fa-ellipsis-vertical fa-lg"
                                    ></i
                                  ></a>
                                </div>

                                <p
                                  style="
                                    font-size: 0.8rem;
                                    margin-bottom: 10px;
                                    background-color: #5b0eeb;
                                    width: 100px;
                                    padding: 4px;
                                    border-radius: 40px;
                                    color: aliceblue;
                                  "
                                  class="text-center"
                                >
                                  <b>IN PROGRESS</b>
                                </p>
                                <p
                                  style="font-size: 1.2rem"
                                  class="justify-content-center mb-0"
                                >
                                  {{ inlocker.room_name }}
                                </p>
                                <span
                                  v-if="inlocker.trans_status === 'inlocker'"
                                >
                                  <router-link
                                    :to="'/locker/' + inlocker.locker_number"
                                    class="nav-link pull-right"
                                    target="_blank"
                                  >
                                    <b-button
                                      variant="outline-purple"
                                      pill
                                      class="pull-right mb-2 mt-0 pull-right"
                                      size="sm"
                                      >รับกุญแจ</b-button
                                    >
                                  </router-link>

                                  <!-- ************************************************************** MODAL CONFIRM AFTERNOON ************************************************************** -->

                                  <!-- ************************************************************** END MODAL CONFIRM AFTERNOON  ************************************************************** -->
                                </span>
                              </div>

                              <!-- =============================================================== MODAL DETAIL AFTERNOON  =========================================================== -->
                              <div
                                :id="`open-modal-inlocker${inlocker.order_id}`"
                                class="modal-window"
                              >
                                <div>
                                  <a href="#" title="Close" class="modal-close"
                                    ><i class="fa-solid fa-xmark fa-2x mt-3"></i
                                  ></a>
                                  <h1 class="justify-content-center text-left">
                                    {{ inlocker.room_name }}
                                  </h1>
                                  <p class="justify-content-center text-left">
                                    TIME : {{ inlocker.time_begin }} -
                                    {{ inlocker.time_end }}
                                  </p>
                                  <p class="justify-content-center text-left">
                                    NAME : {{ inlocker.whois_std_name }}
                                  </p>
                                  <p class="justify-content-center text-left">
                                    STD CODE : {{ inlocker.whois_std_code }}
                                  </p>
                                  <p class="justify-content-center text-left">
                                    LOCKER : {{ inlocker.locker_number }}
                                  </p>
                                  <p class="justify-content-center text-left">
                                    DATE : {{ inlocker.meeting_date | moment }}
                                  </p>

                                  <div>
                                    <small>
                                      รายละเอียดการจองห้องศึกษากลุ่มย่อย
                                    </small>
                                  </div>
                                </div>
                              </div>
                              <!-- =============================================================== END MODAL DETAIL AFTERNOON  =========================================================== -->
                            </div>
                          </span>
                        </span>
                      </div>

                      <!--  =================================================== END IN PROGRESS AFTERNOON   ===================================================-->

                      <!--  =================================================== BORROWED AFTERNOON   ===================================================-->

                      <div class="card-columns-three">
                        <span v-for="(borrowed, ind) in histories" :key="ind">
                          <span
                            v-if="
                              [1, 2, 3, 4, 5, 6, 7, 24, 25, 26, 27].includes(
                                borrowed.room_id
                              ) && borrowed.time_begin === '13:00'
                            "
                          >
                            <div
                              class="card card-order-list card-margin shadow-item shadow-sm"
                              v-if="
                                choosedDay2.dateFormat.moment ===
                                  borrowed.meeting_date.moment &&
                                borrowed.trans_status === 'borrowed' &&
                                borrowed.time_begin === '13:00'
                              "
                            >
                              <div
                                class="card-body text-left"
                                style="position: relative"
                              >
                                <div
                                  style="
                                    position: absolute;
                                    font-size: 14px;
                                    color: black;
                                    right: 10px;
                                    margin-top: -10px;
                                  "
                                  class="interior"
                                >
                                  <a
                                    class="btn"
                                    :href="`#open-modal-borrowed${borrowed.order_id}`"
                                    ><i
                                      class="fa-solid fa-ellipsis-vertical fa-lg"
                                    ></i
                                  ></a>
                                </div>

                                <p
                                  style="
                                    font-size: 0.8rem;
                                    margin-bottom: 10px;
                                    background-color: #28a745;
                                    width: 100px;
                                    padding: 4px;
                                    border-radius: 40px;
                                    color: aliceblue;
                                  "
                                  class="text-center"
                                >
                                  <b>BORROWED</b>
                                </p>
                                <p
                                  style="font-size: 1.2rem"
                                  class="justify-content-center mb-0"
                                >
                                  {{ borrowed.room_name }}
                                </p>

                                <!-- ************************************************************** MODAL CONFIRM AFTERNOON ************************************************************** -->

                                <!-- ************************************************************** END MODAL CONFIRM AFTERNOON  ************************************************************** -->
                              </div>

                              <!-- =============================================================== MODAL DETAIL AFTERNOON  =========================================================== -->
                              <div
                                :id="`open-modal-borrowed${borrowed.order_id}`"
                                class="modal-window"
                              >
                                <div>
                                  <a href="#" title="Close" class="modal-close"
                                    ><i class="fa-solid fa-xmark fa-2x mt-3"></i
                                  ></a>
                                  <h1 class="justify-content-center text-left">
                                    {{ borrowed.room_name }}
                                  </h1>
                                  <p class="justify-content-center text-left">
                                    TIME : {{ borrowed.time_begin }} -
                                    {{ borrowed.time_end }}
                                  </p>
                                  <p class="justify-content-center text-left">
                                    NAME : {{ borrowed.whois_std_name }}
                                  </p>
                                  <p class="justify-content-center text-left">
                                    STD CODE : {{ borrowed.whois_std_code }}
                                  </p>
                                  <p class="justify-content-center text-left">
                                    LOCKER : {{ borrowed.locker_number }}
                                  </p>
                                  <p class="justify-content-center text-left">
                                    DATE : {{ borrowed.meeting_date | moment }}
                                  </p>

                                  <div>
                                    <small>
                                      รายละเอียดการจองห้องศึกษากลุ่มย่อย
                                    </small>
                                  </div>
                                </div>
                              </div>
                              <!-- =============================================================== END MODAL DETAIL AFTERNOON  =========================================================== -->
                            </div>
                          </span>
                        </span>
                      </div>
                      <!--  =================================================== END BORROWED AFTERNOON   ===================================================-->
                    </b-card-body>
                  </b-collapse>
                </b-card>
              </div>
              <!-- =============================== END After noon  =============================== -->
            </div>
          </div>
          <div class="col"></div>
        </div>
      </div>
    </span>
    <!-- *********************************************END METTING ROOM ********************************* -->
  </div>
</template>

<script>
import navbarStaff from "../layouts/navbar_staff.vue";
import VueHorizontalCalendar from "vue-horizontal-calendar";
import "@fullcalendar/core/vdom";
import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin from "@fullcalendar/interaction";
import moment from "moment";
import FullCalendar from "@fullcalendar/vue";
import axios from "axios";
import $ from "jquery";
export default {
  components: { navbarStaff, VueHorizontalCalendar, FullCalendar },
  data() {
    return {
      calendarOptions: {
        plugins: [dayGridPlugin, interactionPlugin],
        initialView: "dayGridMonth",
        dateClick: this.handleDateClick,
        events: [
          {},
          // title: 'event 2', date: '2019-04-02'
        ],
      },
      attributes: [
        {
          key: "today",
          highlight: true,
          dates: new Date(),
        },
        {
          key: 1,
          customData: {
            title: "Lunch with mom.",
            class: "bg-red-600 text-white",
          },
          dates: new Date(),
        },
      ],
      dateTime: new Date(),
      choosedDay2: {
        dateFormat: "",
        year: "",
        month: "",
        date: "",
        day: "",
        timestamp: "",
      },

      fields: [
        { key: "index", label: "ลำดับ" },
        { key: "room_name", label: "Room", sortable: true },
        { key: "whois_std_name", label: "Name" },
        { key: "whois_std_code", label: "STD Code" },
        { key: "locker_number", label: "Locker" },
        { key: "locker_passcode", label: "Password" },
        { key: "time_begin", label: "Start" },
        { key: "time_end", label: "End" },
        { key: "meeting_date", label: "Date" },
        { key: "trans_status", label: "Status" },
      ],
      time: "",
      date: "",
      week: ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"],
      check_time_moorning: true,
      check_status_studio_room: [],
      time_count: "",

      ready: [],
      token: "dQpojB8WkH7HAZdh223jaqFSB1x5RYoKBjU0BAaVZt8DTVaxO5Sx5DlsErA2Zsu",
      tokenjong: "NDMyMTNDNUYtRkZFNy00NjI1LUIwNTQtMkQ0QTkzOTIyQTM3",

      text: "",
      radio_btn: "",

      readMore: {},
      isLoading: false,
      show: false,
      orderMore: {},
      s: [],
      newjobs: [],
      myjobs: [],
      packing: [],
      code: "",
      value: "",
      context: null,
      histories: [],

      thirty: "",
      status_room: [],
      list: [],
      calendar_his: [],
      confirmed: false,
      dismissSecs: 10,
      dismissCountDown: 0,
      showDismissibleAlert: false,
      showDismissibleAlertDanger: false,
      showDismissibleAlert_end: false,
      showDismissibleAlertDanger_end: false,
      showBorrowReturnSuccess: false,
      showBorrowReturnDanger: false,
      showStatusinlockerSuccess: false,
      showStatusinlockerDanger: false,
      message_return: "",
      statusalert: false,
      message_inlocker: "",
      message_end: "",
      message: "",
      items_table: [],

      isOpen1: true,
      isOpen2: true,
      selected1: "Student-Centered Learning",
      selected2: "Formative Assessment",
      currentTime: "",
      // count item menu booking room
      booked: "",
      inProgress: "",
      borrowed: "",
      returned: "",
    };
  },
  filters: {
    moment: function (date) {
      moment.locale("en");
      // return moment(date).add(543, "year").format("LL");
      return moment(date).format("LL");
    },
    formattime: function (date) {
      moment.locale("th");

      return moment(date).format("hh:mm");
    },
    thirtyminutes: function (date) {
      moment.locale("th");
      return moment(date).add(30, "minutes").format("hh:mm");
    },
  },
  mounted() {
    // this.startCountdown();
    // let timmer = new Date();
    // this.thirty = timmer.getMinutes();
    if (localStorage.getItem("auth") != null) {
      this.user = false;
      this.auth = JSON.parse(localStorage.getItem("auth"));
      this.code = this.auth.std_code;
      // console.log(this.auth);
      if (this.auth.user_type === "Teacher" || this.auth.isLibraryStaff === 0) {
        this.isShowstaff;
      } else if (this.auth.user_type === "Student") {
        this.isShowstaff = true;
      }

      if (this.auth.isLibraryStaff === 1) {
        this.staff = true;
      } else {
        this.staff = false;
      }
    } else {
      this.user = true;
      this.isShowstaff = true;
    }

    let nextTimeRenew = new Date().getTime() + 3600 * 1000;
    // const dateTime = new Date();
    // const hours = dateTime.getHours().toString().padStart(2, "0");
    // const minutes = dateTime.getMinutes().toString().padStart(2, "0");
    // const seconds = dateTime.getSeconds().toString().padStart(2, "0");

    // const currentTime = `${hours}:${minutes}:${seconds}`;
    // console.log(currentTime);

    var clear = setInterval(() => {
      let timeNow = new Date().getTime();
      var timeOut = nextTimeRenew - timeNow;
      var minute = Math.floor((timeOut % (1000 * 60 * 60)) / (1000 * 60));
      var second = Math.floor((timeOut % (1000 * 60)) / 1000);

      // console.log(nextTimeRenew );

      if (minute <= 0 && second <= 0) {
        clearInterval(clear);
      } else {
        this.time_count = `${minute}:${second < 10 ? "0" + second : second}s`;
        // document.body.innerHTML = `0${minute}:${
        // 	second < 10 ? "0" + second : second
        // }s`;
      }
    }, 1000);

    /*  play button */

    // eslint-disable-next-line no-unused-vars
    const playBtn = document.querySelector(".circle__btn");
    // console.log(playBtn);
    // eslint-disable-next-line no-unused-vars
    const wave1 = document.querySelector(".circle__back-1");
    // console.log(wave1);
    // eslint-disable-next-line no-unused-vars
    const wave2 = document.querySelector(".circle__back-2");
    // console.log(wave2);

    //
    window.setTimeout(function () {
      $(".alert")
        .fadeTo(500, 0)
        .slideUp(500, function () {
          $(this).remove();
        });
    }, 4000);
    //
    /*! Main */

    this.getready();
    // let hour ;
    this.getHistoryAll();
     setInterval(() => {
      this.getHistoryAll();
    }, 15000);

    // eslint-disable-next-line no-unused-vars
    var timerID = setInterval(this.updateTime, 1000);
    // console.log(timerID);
    this.updateTime();
    // this.checkPeriod();

    // const minute = now.getMinutes().toString().padStart(2, '0')
  },
  computed: {
    minutes() {
      return String(Math.floor(this.time / 60)).padStart(2, "0");
    },
    seconds() {
      return String(this.time % 60).padStart(2, "0");
    },
  },
  methods: {
    onChange() {
      // console.log(this.radio_btn);
      this.getcalendar();
    },
    confirm_chk(test) {
      // eslint-disable-next-line no-unused-vars
      let a = test;
      // console.log("modal confirm", test);
    },
    showMore(id) {
      // console.log("show more", id);
      this.$set(this.readMore, id, true);
      // if(id){
      //   this.readMore= true;
      // }
    },
    showLess(id) {
      this.$set(this.readMore, id, false);
    },

    showCalendarFuc() {
      this.showCalendar = true;
      this.getcalendar();
    },
    closeCalendar() {
      this.showCalendar = false;
    },
    getready() {
      let data = {
        token: this.token,
        staff_code: this.code,
      };
      const headers = {
        "content-type": "application/json",
      };
      this.$isLoading(true);
      axios
        .post("https://smartlibrary.ubru.ac.th/api/booking/get_ready", data, {
          headers,
        })
        .then((res) => {
          this.ready = res.data.Orders;
          this.s = this.ready.length;
          this.packing = res.data.dasboard[0].packing;
          this.newjobs = res.data.dasboard[0].neworders;
          this.myjobs = res.data.dasboard[0].myjob;
          this.$isLoading(false);
        });
    },
    dateChange2(day) {
     //console.log(day, "check date day");
      this.list = [];
      if (localStorage.getItem("auth") != null) {
        this.user = false;
        this.auth = JSON.parse(localStorage.getItem("auth"));
        this.code = this.auth.std_code;
        // console.log(this.auth);
        if (this.auth.user_type === "Teacher") {
          this.isShowstaff;
          // console.log("Teacher");
        } else if (
          this.auth.user_type === "Student" ||
          this.auth.isLibraryStaff != 0
        ) {
          this.isShowstaff = true;
          // console.log("Student");
        }

        if (this.auth.isLibraryStaff === 1) {
          this.staff = true;
        } else {
          this.staff = false;
        }
      } else {
        this.user = true;
        this.isShowstaff = true;
        // console.log("anothor");
      }

      this.choosedDay2 = day;
      this.date = this.choosedDay2.dateFormat;
      let data = {
        select_date: this.choosedDay2.dateFormat,
      };
      // console.log("datetime ====", data);
      const token = this.tokenjong;
      const headers = {
        Authorization: `Bearer ${token}`,
      };

      axios
        .post(
          "https://smartlibrary.ubru.ac.th/api/step1_getroom_status",
          data,
          { headers }
        )
        .then((res) => {
          // console.log(res);
          this.status_room = res.data.room_status;

          this.status_room.forEach((item) => {
            if (item.freetimes.length !== 0) {
              this.list.push(item);
            }
          // console.log("chk",item);
          });

         this.getHistoryAll();
        });
    },

    getHistoryAll() {
      // this.calendarOptions.events = [];
      let data = {
        select_date: this.choosedDay2.dateFormat,
      };
      this.check_status_studio_room = [];
      // console.log("get story data ==", data);
      const token = this.tokenjong;
      const headers = {
        Authorization: `Bearer ${token}`,
      };
      axios
        .post("https://smartlibrary.ubru.ac.th/api/get_history_all", data, {
          headers,
        })
        .then((res) => {
          console.log("HISTORY STUDIO ====",res);
          
          if (res.data.msg.status === 200) {
            this.histories = res.data.histories;
            this.items_table = res.data.histories;
            const booked__ = [];
            const inprogress__ = [];
            const borrowed__ = [];
            const return__ = [];
            const check_status_studio_room__ = [];

            this.histories.forEach((item) => {
              if (
                item.room_id === 8 ||
                item.room_id === 9 ||
                item.room_id === 10
              ) {
                check_status_studio_room__.push(item);
              }

              if (
                item.trans_status === "booked" &&
                item.room_id !== 8 &&
                item.room_id !== 9 &&
                item.room_id !== 10
              ) {
                booked__.push(item);
              }

              if (
                item.trans_status === "inlocker" &&
                item.room_id !== 8 &&
                item.room_id !== 9 &&
                item.room_id !== 10
              ) {
                inprogress__.push(item);
              }

              if (
                item.trans_status === "borrowed" &&
                item.room_id !== 8 &&
                item.room_id !== 9 &&
                item.room_id !== 10
              ) {
                borrowed__.push(item);
              }

              if (
                item.trans_status === "returned" &&
                item.room_id !== 8 &&
                item.room_id !== 9 &&
                item.room_id !== 10
              ) {
                return__.push(item);
              }

              // console.log(item.room_id);
            });

            this.booked = booked__.length;
            this.inProgress = inprogress__.length;
            this.borrowed = borrowed__.length;
            this.returned = return__.length;
            this.check_status_studio_room = check_status_studio_room__.length;
            console.log("count booked", this.check_status_studio_room );

            // console.log("chk === ",this.histories[0].meeting_datemoment('hh:mm'));
            // this.calendar_his = res.data.motnly_histories;
          } else {
            alert(res.data.msg.message);
          }

          // console.log("History", this.histories);
          if (this.histories.length === 0) {
            this.status_show = false;
          } else {
            // console.log("true");
            this.status_show = true;
          }
        });
    },
    getcalendar() {
      // console.log("Get calendar");
      this.calendarOptions.events = [];
      let data = {
        select_date: this.choosedDay2.dateFormat,
      };
      // console.log("get story data ==", data);
      const token = this.tokenjong;
      const headers = {
        Authorization: `Bearer ${token}`,
      };
      axios
        .post("https://smartlibrary.ubru.ac.th/api/get_history_all", data, {
          headers,
        })
        .then((res) => {
          // console.log(this.calendar_his);
          if (res.data.msg.status === 200) {
            // this.histories = res.data.histories;
            this.calendar_his = res.data.motnly_histories;
            this.calendar_his.forEach((item) => {
              this.calendarOptions.events.push({
                title: item.room_name,
                date: item.meeting_date.slice(0, 10),
              });
            });
          } else {
            alert(res.data.msg.message);
          }

          // console.log("History", this.histories);
          if (this.histories.length === 0) {
            this.status_show = false;
          } else {
            // console.log("true");
            this.status_show = true;
          }
        });
    },

    checkSTD(event) {
      // console.log("Enter key ===", event.keyCode);
      // if (event.key === "Meta" || event.key === "Control") {
      //   console.log();
      // } else {
      // console.log("Enter key ===", event.key);
      // console.log("enter");
      if (event.keyCode === 13) {
        let data = {
          std_code: this.text,
        };

        const token = this.tokenjong;
        const headers = {
          Authorization: `Bearer ${token}`,
        };
        axios
          .post(
            "https://smartlibrary.ubru.ac.th/api/step4_borrow_return",
            data,
            {
              headers,
            }
          )
          .then((res) => {
            if (res.data.msg.status === 200) {
              this.message_return = res.data.msg.message;
              this.showBorrowReturnSuccess = true;
              this.histories = res.data.histories;
              this.text = "";
            } else {
              this.showBorrowReturnDanger = true;
              this.message_return = res.data.msg.message;
              this.text = "";
            }
          });
      } else {
        // console.log("event key code !=== 13");
      }

      // ยืนยันการเข้าใช้งานห้อง และ คืนห้อง
    },
    approve(order_token) {
      let data = {
        order_token: order_token,
        staff_code: this.code,
      };
      const token = this.tokenjong;
      const headers = {
        Authorization: `Bearer ${token}`,
      };
      this.$isLoading(true);
      axios
        .post("https://smartlibrary.ubru.ac.th/api/room/approve ", data, {
          headers,
        })
        .then((res) => {
          if (res.data.msg.status !== 200) {
            // console.log("500");
            this.message = res.data.msg.message;
            this.showDismissibleAlertDanger = true;
            this.$isLoading(false);
          } else {
            // console.log("200");
            this.histories = res.data.histories;
            this.message = res.data.msg.message;
            if (res.data.histories.trans_status === "completed") {
              this.statusalert = true;
            }
            this.showDismissibleAlert = true;
            this.$isLoading(false);
          }
        });
    },
    ok() {
      // console.log("ok");
    },
    end(order_token) {
      // console.log(order_token);
      this.$bvModal.hide(order_token);
      let data = {
        order_token: order_token,
        staff_code: this.code,
      };
      // console.log(data);
      const token = this.tokenjong;
      const headers = {
        Authorization: `Bearer ${token}`,
      };
      this.$isLoading(true);
      axios
        .post("https://smartlibrary.ubru.ac.th/api/room/end_of_usage", data, {
          headers,
        })
        .then((res) => {
          // console.log("end == ", res);
          if (res.data.msg.status !== 200) {
            // console.log("500");
            this.message_end = res.data.msg.message;
            this.showDismissibleAlertDanger_end = true;
            this.$isLoading(false);
            // this.$bvModal.hide(order_token);
          } else {
            // console.log("200");
            this.histories = res.data.histories;
            this.message_end = res.data.msg.message;
            if (res.data.histories.trans_status === "completed") {
              this.statusalert = true;
            }
            this.showDismissibleAlert_end = true;
            this.$isLoading(false);
          }
        });
    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown;
    },
    showAlert() {
      this.dismissCountDown = this.dismissSecs;
    },
    inlocker(order_id) {
      let data = {
        order_id: order_id,
        staff_code: this.code,
      };
      // console.log(data);
      const token = this.tokenjong;
      const headers = {
        Authorization: `Bearer ${token}`,
      };

      this.$isLoading(true);
      axios
        .post("https://smartlibrary.ubru.ac.th/api/room/inlocker", data, {
          headers,
        })
        .then((res) => {
          // console.log("inlocker == ", res);
          if (res.data.msg.status !== 200) {
            // console.log("500");
            this.message_inlocker = res.data.msg.message;
            this.showStatusinlockerDanger = true;
            this.$isLoading(false);
          } else {
            // console.log("200");
            this.histories = res.data.histories;
            this.message_inlocker = res.data.msg.message;
            if (res.data.histories.trans_status === "completed") {
              this.statusalert = true;
            }
            this.showStatusinlockerSuccess = true;
            this.$isLoading(false);
          }
        });
    },
    checkPeriod() {
      const now = new Date();
      const hour = now.getHours();
      const minute = now.getMinutes().toString().padStart(2, "0");
      this.currentTime = `${hour.toString().padStart(2, "0")}:${minute}`;

      if (hour < 12) {
        this.isOpen1 = true;
        this.isOpen2 = false;
      } else {
        this.isOpen1 = false;
        this.isOpen2 = true;
      }
    },
    updateTime() {
      var cd = new Date();

      // datetime.getMinutes()+30
      this.time =
        this.zeroPadding(cd.getHours(), 2) +
        ":" +
        this.zeroPadding(cd.getMinutes(), 2);
      // ":" +
      // this.zeroPadding(cd.getSeconds(), 2);
      this.date =
        this.zeroPadding(cd.getFullYear(), 4) +
        "-" +
        this.zeroPadding(cd.getMonth() + 1, 2) +
        "-" +
        this.zeroPadding(cd.getDate(), 2) +
        " " +
        this.week[cd.getDay()];

      // // ดึงชั่วโมงและนาที
      // const h = now.getHours().toString().padStart(2, "0");
      // const m = now.getMinutes().toString().padStart(2, "0");

      // // สร้างเป็น string รูปแบบ HH:MM
      // const currentTime = `${h}:${m}`;
    },
    zeroPadding(num, digit) {
      var zero = "";
      for (var i = 0; i < digit; i++) {
        zero += "0";
      }
      return (zero + num).slice(-digit);
    },
    handleSubmit() {
      // console.log("test modal");
      // Exit when the form isn't valid
      // if (!this.checkFormValidity()) {
      //   return
      // }
      // // Push the name to submitted names
      // this.submittedNames.push(this.name)
      // // Hide the modal manually
      // this.$nextTick(() => {
      //   this.$bvModal.hide('modal-prevent-closing')
      // })
    },
    cancelRoom(val) {
      console.log(val);
    },
  },
};
</script>

<style lang="scss" scoped>
@import url("https://fonts.googleapis.com/css2?family=Kanit:wght@100;200&display=swap");

.meetingStaff {
  background: var(--greyLight-1) no-repeat center center;
  background-size: cover;
  min-height: 100vh;
  position: absolute;
  width: 100%;
}
.modal-content h5,
h4,
.btn {
  font-family: "Kanit", sans-serif !important;
}
.space {
  height: 100px;
}
.space_avatar {
  height: 60px;
}

/*  Avatar BUTTON  */
.circle_content {
  position: relative;
}
.circle_img {
  width: 100%;
  height: auto;
  border-radius: 50%;
}
.circle_floting {
  position: absolute;
  /* width: 46px;
  height: 40px;
  
  color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  font-size: 12px; */
  bottom: -25px;
  left: -22px;
  font-size: 14px;
}
.circle {
  grid-column: 2/3;
  grid-row: 4/6;
  width: 9rem;
  height: 100%;
  justify-self: center;
  border-radius: 1rem;
  display: grid;
  grid-template-rows: 1fr;
  justify-items: center;
  align-items: center;
}
.circle__btn {
  grid-row: 1/2;
  grid-column: 1/2;
  width: 9rem;
  height: 6rem;
  display: flex;
  margin: 0.6rem;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  font-size: 3.2rem;
  color: var(--primary);
  z-index: 300;
  background: var(--greyLight-1);
  box-shadow: 0.3rem 0.3rem 0.6rem var(--greyLight-2),
    -0.2rem -0.2rem 0.5rem var(--white);
  cursor: pointer;
  position: relative;
}
.circle__btn.shadow {
  box-shadow: inset 0.2rem 0.2rem 0.5rem var(--greyLight-2),
    inset -0.2rem -0.2rem 0.5rem var(--white);
}
.circle__btn .play {
  position: absolute;
  opacity: 0;
  transition: all 0.2s linear;
}
.circle__btn .play.visibility {
  opacity: 1;
}
.circle__btn .pause {
  position: absolute;
  transition: all 0.2s linear;
}
.circle__btn .pause.visibility {
  opacity: 0;
}
.circle__back-1,
.circle__back-2 {
  grid-row: 1/2;
  grid-column: 1/2;
  width: 6rem;
  height: 6rem;
  border-radius: 50%;
  filter: blur(1px);
  z-index: 100;
}
.circle__back-1 {
  box-shadow: 0.4rem 0.4rem 0.8rem var(--greyLight-3),
    -0.4rem -0.4rem 0.8rem var(--white);
  background: linear-gradient(
    to bottom right,
    var(--greyLight-3) 0%,
    var(--white) 100%
  );
  -webkit-animation: waves 4s linear infinite;
  animation: waves 4s linear infinite;
}
.circle__back-1.paused {
  -webkit-animation-play-state: paused;
  animation-play-state: paused;
}
.circle__back-2 {
  box-shadow: 0.4rem 0.4rem 0.8rem var(--greyLight-3),
    -0.4rem -0.4rem 0.8rem var(--white);
  -webkit-animation: waves 4s linear 2s infinite;
  animation: waves 4s linear 2s infinite;
}
.circle__back-2.paused {
  -webkit-animation-play-state: paused;
  animation-play-state: paused;
}

@-webkit-keyframes waves {
  0% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    opacity: 1;
  }
  100% {
    transform: scale(2);
    opacity: 0;
  }
}

@keyframes waves {
  0% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    opacity: 1;
  }
  100% {
    transform: scale(2);
    opacity: 0;
  }
}
/*END */

.clash-card__unit-stats .alarm-inlocker:hover {
  background-color: #d153e8;
  border-bottom-left-radius: 14px;
}
.clash-card__unit-stats .cancel-inlocker:hover {
  /*#fb9b6f #ea8056*/
  background-color: #d153e8;
  border-bottom-right-radius: 14px;
}
.clash-card__unit-stats {
  color: white;
  font-weight: 700;
  border-bottom-left-radius: 14px;
  border-bottom-right-radius: 14px;

  .one-third {
    width: 50%;
    float: left;
    padding: 5px 2.5px;
  }

  sup {
    position: absolute;
    bottom: 4px;
    font-size: 45%;
    margin-left: 2px;
  }

  .stat {
    position: relative;
    font-size: 18px;
    margin-bottom: 10px;
  }

  .stat-value {
    text-transform: uppercase;
    font-weight: 400;
    font-size: 12px;
  }
}
.clash-card__unit-stats .no-border {
  border-right: none;
}
.clash-card__unit-stats--barbarian {
  background: rgb(181, 5, 245);

  /*  var(--bade-orange) #d153e8#d37b89 rgb(181, 5, 245) #ea8056;*/
  .one-third {
    border-right: 1px solid #d153e8;
  }
}
.clearfix:after {
  visibility: hidden;
  display: block;
  font-size: 0;
  content: " ";
  clear: both;
  height: 0;
}
/**/

/*  TEBS SEGMENTED-CONTROL */
.tebs_content {
  position: relative;
}
.tebs_floting {
  position: absolute;
  /* width: 46px;
  height: 40px;
  
  color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  font-size: 12px; */
  bottom: -50px;
  right: 0px;
  font-size: 14px;
}
.segmented-control {
  grid-column: 3/4;
  grid-row: 1/2;
  width: 17.9rem;
  height: 3rem;
  box-shadow: 0.3rem 0.3rem 0.6rem var(--greyLight-2),
    -0.2rem -0.2rem 0.5rem var(--white);
  border-radius: 1rem;
  display: flex;
  align-items: center;
  position: relative;
}
.segmented-control input {
  display: none;
}
.segmented-control > input:checked + label {
  transition: all 0.5s ease;
  color: rgb(209, 95, 2);
}
.segmented-control__1,
.segmented-control__2,
.segmented-control__3 {
  width: 6rem;
  height: 3.6rem;
  font-size: 1rem;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  color: #ff5f2d;
  transition: all 0.5s ease;
  margin-top: 1.5rem;
}
.segmented-control__1:hover,
.segmented-control__2:hover,
.segmented-control__3:hover {
  color: rgb(209, 95, 2);
}
.segmented-control__color {
  position: absolute;
  height: 2.5rem;
  width: 5.5rem;
  margin-left: 0.3rem;
  border-radius: 0.8rem;
  box-shadow: inset 0.2rem 0.2rem 0.5rem var(--greyLight-2),
    inset -0.2rem -0.2rem 0.5rem var(--white);
  pointer-events: none;
}

#tab-1:checked ~ .segmented-control__color {
  transform: translateX(0);
  transition: transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}

#tab-2:checked ~ .segmented-control__color {
  transform: translateX(5.8rem);
  transition: transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}

#tab-3:checked ~ .segmented-control__color {
  transform: translateX(11.8rem);
  transition: transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}
/*ENE tabs*/
.calendar-border {
  border: none;
  background-color: var(--greyLight-1);
  border-radius: 2rem;
  box-shadow: 0.8rem 0.8rem 1.4rem var(--greyLight-2),
    -0.2rem -0.2rem 0.5rem var(--greyLight-1);
}
.shadow-item {
  border: none;
  background-color: var(--greyLight-1);
  border-radius: 2rem;
}
.shadow-date {
  border-radius: 2rem;
  box-shadow: 0.8rem 0.8rem 1.4rem var(--greyLight-2),
    -0.2rem -0.2rem 1.8rem var(--white);
}

.room-name {
  margin-left: 0px;
}
.card-header:first-child {
  /* border-radius: 0px; */
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
}
.card-columns .card {
  border-radius: 20px;
}
.calendar-list .card {
  border-radius: 20px;
}

.btn-floating-approve {
  position: absolute;
  /* top: -0px; */
  right: 0px;
  /* top: -100px; */
  font-size: 16px;
  /* color: rgb(186, 86, 79); */
  font-weight: bold;
  margin-top: -30px;
}
.btn-floating-cancle {
  position: absolute;
  /* top: -0px; */
  /* right: 0px; */
  /* top: -100px; */
  font-size: 17px;
  /* color: rgb(186, 86, 79); */
  font-weight: bold;
  margin-top: 16px;
  margin-left: 0px;
}
.card-approve {
  position: relative;
}

.card .card_image {
  width: inherit;
  height: inherit;
  border-radius: 20px;
}

.card .card_image img {
  width: inherit;
  height: inherit;
  border-radius: 20px;
  object-fit: cover;
}

.card-content-more {
  position: relative;
  color: orangered;
}

.form-group button {
  margin-bottom: 20px;
}
#button {
  border-radius: 30px;
}
.form-group input {
  margin-bottom: 20px;
}


.input-style {
  border-radius: 30px;
  background-color: #ffffff;
  border-color: #cecece;
  color: #000000;
}
/* card booked Status*/
.card-status-booking {
  border: none;
  background-color: var(--greyLight-1);
  border-radius: 2rem;
  box-shadow: 0.8rem 0.8rem 1.4rem var(--greyLight-2),
    -0.2rem -0.2rem 1.8rem var(--white);
}
.b-between {
  margin-right: 5px !important;
  margin-bottom: 5px;
}

/* End */

/*  SEARCH  */
.search {
  grid-column: 3/4;
  grid-row: 2/3;
  position: relative;
  display: flex;
  align-items: center;
}
.search__input {
  width: 100%;
  height: 3.4rem;
  border: none;
  border-radius: 1rem;
  font-size: 1.4rem;
  padding-left: 3.8rem;
  box-shadow: inset 0.2rem 0.2rem 0.5rem var(--greyLight-2),
    inset -0.2rem -0.2rem 0.5rem var(--white);
  background: none;
  font-family: inherit;
  color: var(--greyDark);
}
.search__input::-moz-placeholder {
  color: var(--greyLight-3);
}
.search__input:-ms-input-placeholder {
  color: var(--greyLight-3);
}
.search__input::placeholder {
  color: var(--greyLight-3);
}
.search__input:focus {
  outline: none;
  box-shadow: 0.3rem 0.3rem 0.6rem var(--greyLight-2),
    -0.2rem -0.2rem 0.5rem var(--white);
}
.search__input:focus + .search__icon {
  color: orangered;
}
.search__icon {
  height: 1.3rem;
  position: absolute;
  font-size: 1.5rem;
  padding: 0 1.5rem;
  display: flex;
  color: var(--greyDark);
  transition: 0.3s ease;
}
/* Morrning */
.text-capitalize {
  border: none;
  border-radius: 1rem;
  font-size: 1.4rem;
  padding-left: 3.8rem;
  box-shadow: inset 0.2rem 0.2rem 0.5rem var(--greyLight-2),
    inset -0.2rem -0.2rem 0.5rem var(--white);
  background: none;
  font-family: inherit;
  color: rgb(0, 0, 0);
  font-weight: bold;
}
/**Canceled*/
.capitalize-canceled {
  border: none;
  border-radius: 1rem;
  font-size: 1rem;
  padding: 1rem;
  box-shadow: inset 0.2rem 0.2rem 0.5rem var(--greyLight-2),
    inset -0.2rem -0.2rem 0.5rem var(--white);
  background: none;
  font-family: inherit;
  color: orangered;
  font-weight: bold;
}
.capitalize-canceled p {
  margin-bottom: 0rem;
}

/* END */
/* card */
@media (max-width: 900px) {
  .circle_floting {
    position: absolute;
    /* width: 46px;
    height: 40px;
    
    color: #ffffff;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    font-size: 12px; */
    bottom: 0px;
    left: -15px;
    font-size: 14px;
  }
  .card-columns {
    column-count: 1;
  }
  .card-columns-two {
    column-count: 1;
  }
  .card-columns-left-item {
    column-count: 1;
  }
  .card-columns-three {
    column-count: 1;
  }
}
@media (min-height: 414px) {
  .card-columns {
    column-count: 1;
  }
  .card-columns-two {
    column-count: 1;
  }
  .card-columns-left-item {
    column-count: 1;
  }
  .card-columns-three {
    column-count: 1;
  }
}
@media (max-height: 500px) {
  .card-columns {
    column-count: 1;
  }
  .card-columns-two {
    column-count: 1;
  }
  .card-columns-left {
    column-count: 1;
  }
  .card-columns-left-item {
    column-count: 1;
  }
  .card-columns-three {
    column-count: 1;
  }
}
@media (min-width: 768px) {
  .card-columns {
    column-count: 1;
  }
  .card-columns-two {
    column-count: 2;
  }
  .card-columns-left {
    column-count: 1;
  }
  .card-columns-left-item {
    column-count: 1;
  }

  .card-columns-right-item {
    column-count: 3;
  }
  .time-column {
    column-count: 1;
  }
  h6 {
    margin-top: 10px;
  }
  .card-columns-three {
    column-count: 1;
  }
}

/* Large devices (desktops, 992px and up) */
@media (min-width: 992px) {
  .card-columns {
    column-count: 1;
  }
  .card-columns-two {
    column-count: 2;
  }
  .card-columns-left {
    column-count: 1;
  }
  .card-columns-left-item {
    column-count: 2;
  }
  .card-columns-right-item {
    column-count: 3;
  }
  .time-column {
    column-count: 1;
  }
  h6 {
    margin-top: 10px;
  }
  .card-columns-three {
    column-count: 3;
  }
}

/* Extra large devices (large desktops, 1200px and up) */
@media (min-width: 1200px) {
  .card-columns {
    column-count: 1;
  }
  .card-columns-two {
    column-count: 2;
  }
  .card-columns-three {
    column-count: 3;
  }
  .card-columns-left {
    column-count: 1;
  }
  .card-columns-left-item {
    column-count: 3;
  }
  .card-columns-right-item {
    column-count: 3;
  }
  .time-column {
    column-count: 1;
  }
  h6 {
    margin-top: 10px;
  }
}
.no-footer-border {
  border-top: none !important; /* Remove the footer border */
}
.v-card-actions {
  border-top: none !important;
}

.btn-purple {
  color: #fff;
  border-color: var(--sub-color);
  background-color: var(--purple-color);
}

.btn-purple:hover {
  color: #fff;
  border-color: var(--sub-color);
  background-color: var(--purple-color);
}
.btn-purple:focus,
.btn-purple.focus {
  color: #fff;
  border-color: var(--sub-color);
  background-color: var(--purple-color);
  box-shadow: 0 0 0 0.2rem rgba(160, 72, 180, 0.5);
}
.btn-purple.disabled,
.btn-orange:disabled {
  color: #fff;
  border-color: var(--sub-color);
  background-color: var(--purple-color);
}
.btn-purple:not(:disabled):not(.disabled):active,
.btn-purple:not(:disabled):not(.disabled).active,
.show > .btn-purple.dropdown-toggle {
  color: #fff;
  border-color: var(--sub-color);
  background-color: var(--sub-color);
}
.btn-purple:not(:disabled):not(.disabled):active:focus,
.btn-purple:not(:disabled):not(.disabled).active:focus,
.show > .btn-purple.dropdown-toggle:focus {
  /*rgba(180, 72, 112, 0.5);*/
  box-shadow: 0 0 0 0.2rem rgba(160, 72, 180, 0.5);
}

/*  */

.btn-outline-purple {
  /*#ed3d6f*/
  color: #5b0eeb;
  border-color: #5b0eeb;
}
.btn-outline-purple:hover {
  color: #fff;
  border-color: #5b0eeb;
  background-color: #5b0eeb;
}
.btn-outline-purple:focus,
.btn-outline-purple.focus {
  box-shadow: 0 0 0 0.2rem rgba(160, 72, 180, 0.5);
}
.btn-outline-purple.disabled,
.btn-outline-purple:disabled {
  color: #000000;
  background-color: transparent;
}
.btn-outline-purple:not(:disabled):not(.disabled):active,
.btn-outline-purple:not(:disabled):not(.disabled).active,
.show > .btn-outline-purple.dropdown-toggle {
  color: #fff;
  border-color: #000000;
  background-color: #000000;
}
.btn-outline-purple:not(:disabled):not(.disabled):active:focus,
.btn-outline-purple:not(:disabled):not(.disabled).active:focus,
.show > .btn-outline-purple.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(160, 72, 180, 0.5);
}

/* ปรับให้ layout เป็น 2 คอลัมน์ */
.b-form-radio-group > .custom-control {
  width: 45%;
  display: inline-block;
  margin-right: 5%;
  margin-bottom: 10px;
}

.modal-window {
  position: fixed;
  background-color: rgba(21, 21, 21, 0.414);
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 999;
  visibility: hidden;
  opacity: 0;
  pointer-events: none;
  transition: all 0.3s;
  &:target {
    visibility: visible;
    opacity: 1;
    pointer-events: auto;
  }
  & > div {
    width: 400px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    padding: 2em;
    background: white;
  }
  header {
    font-weight: bold;
  }
  h1 {
    font-size: 150%;
    margin: 0 0 15px;
  }
}

.modal-close {
  color: #aaa;
  line-height: 50px;
  font-size: 80%;
  position: absolute;
  right: 0;
  text-align: center;
  top: 0;
  width: 70px;
  text-decoration: none;
  &:hover {
    color: black;
  }
}

/* Demo Styles */

.modal-window {
  position: fixed;
  background-color: rgba(23, 23, 23, 0.565);
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 999;
  visibility: hidden;
  opacity: 0;
  pointer-events: none;
  transition: all 0.3s;
  &:target {
    visibility: visible;
    opacity: 1;
    pointer-events: auto;
  }
  & > div {
    width: 400px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    padding: 2em;
    background: white;
  }
  header {
    font-weight: bold;
  }
  h1 {
    font-size: 150%;
    margin: 0 0 15px;
  }
}

.modal-close {
  color: #aaa;
  line-height: 50px;
  font-size: 80%;
  position: absolute;
  right: 0;
  text-align: center;
  top: 0;
  width: 70px;
  text-decoration: none;
  &:hover {
    color: black;
  }
}

.modal-window {
  & > div {
    border-radius: 1rem;
  }
}

.modal-window div:not(:last-of-type) {
  margin-bottom: 15px;
}
</style>
